<script>
import ResourceDetail from '@shell/components/ResourceDetail/index.vue';

export default {
  name:       'HarvesterResourcedId',
  components: { ResourceDetail },
};
</script>

<template>
  <ResourceDetail />
</template>
